import AddSeller from "./AddSeller";
import styles from './AddSeller.module.css';

const AddSellerPanel = ({ isFirstSeller, isOzonSeller, onSuccess }: {
  isOzonSeller?: boolean,
  isFirstSeller?: boolean,
  onSuccess?: () => void,
}) => (
  <div className={styles.root}>
    <div className={styles.inner}>
      <AddSeller
        isFirstSeller={isFirstSeller}
        isOzonSeller={isOzonSeller}
        onSuccess={onSuccess}
      />
    </div>
  </div>
)

export default AddSellerPanel;
